import classNames from 'classnames';
import { InfoCircleWhiteIcon } from 'ui/icons';
import { fixNameEnum } from 'ui/utils';
import { ActivitiesStatus, CommunicationStatus } from 'api';

interface ActivityStatusBadgeProps {
  status: ActivitiesStatus | string | CommunicationStatus;
  className?: string;
  isCustomStatus?: boolean;
  info?: boolean;
}

const ActivityStatusBadge = ({
  status,
  className,
  info,
  isCustomStatus,
}: ActivityStatusBadgeProps) => {
  return (
    <span
      className={classNames(
        'flex gap-1',
        'text-[12px] leading-[20px] text-white bg-blue-700 w-fit select-none',
        'rounded-[1000px] px-2 py-[2px] capitalize col-start-1 col-end-2 whitespace-nowrap',
        {
          'bg-blue-700': status === ActivitiesStatus.Pending,
          'bg-warning-orange':
            status === ActivitiesStatus.AwaitingPayment ||
            status === CommunicationStatus.Incompleted,
          'bg-error-red': status === ActivitiesStatus.Unsuccessfull || status === 'cancelled',
          'bg-success-green': status === ActivitiesStatus.Completed,
        },
        className,
      )}
    >
      <span>
        {isCustomStatus
          ? status.replace('unsuccessfull', 'unsuccessful')
          : fixNameEnum(status.replace('unsuccessfull', 'unsuccessful'))}
      </span>
      {info && <img alt="info" src={InfoCircleWhiteIcon} width={18} />}
    </span>
  );
};

export default ActivityStatusBadge;
